
export class TableUtils {

    public static setColumnWidths(colPropNames: string[], entries: any[], cols: any[]): void {

		let maxColDataLength: number[] = [];
		for (let i = 0; i < cols.length; ++i) {
			let col = cols[i];
			maxColDataLength.push(col.header.length);
		}

		for (let i = 0; i < entries.length; ++i) {
			let entry = entries[i];

			for (let j = 0; j < cols.length; ++j) {
				if (entry[colPropNames[j]].length > maxColDataLength[j]) {
					maxColDataLength[j] = entry[colPropNames[j]].length;
				}
			}
		}

		let totalColDataLength = 0;
		maxColDataLength.forEach((n: number) => totalColDataLength += n);

		for (let i = 0; i < cols.length; ++i) {
			let col = cols[i];
			let colWidthPercentage = Math.floor(maxColDataLength[i] / totalColDataLength * 100);
			col.width = `${colWidthPercentage}`;
		}
    }

}